import { render, staticRenderFns } from "./XrfInspResultCopyToInput.vue?vue&type=template&id=f4d64f9a&"
import script from "./XrfInspResultCopyToInput.vue?vue&type=script&lang=js&"
export * from "./XrfInspResultCopyToInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports